module.exports = __webpack_public_path__ + "img/cta-bottom.a81181cc.svg";